import React from "react";
import { HOUSEKEEPING, STAFF } from "../../data/mockData";

export default function Housekeeping() {
  const pending = HOUSEKEEPING.filter(h => h.status === "pending").length;
  const hkStaff = STAFF.filter(s => s.role === "Housekeeping" || s.role === "Maintenance");

  return (
    <div className="g2">
      {/* Cleaning Schedule */}
      <div className="panel">
        <div className="panel-hd">
          <span className="panel-hd-title">Cleaning Schedule</span>
          <span className="badge badge-red">{pending} pending</span>
        </div>
        {HOUSEKEEPING.map(h => (
          <div key={h.room} style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", borderBottom:"1px solid rgba(180,140,80,.07)" }}>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, color:"#2c1f14", minWidth:44 }}>{h.room}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:12.5, color:"#3a2a1a", fontWeight:300 }}>{h.assignedTo}</div>
              <div style={{ fontSize:10.5, color:"#8a7060", marginTop:2 }}>Last cleaned: {h.lastCleaned}</div>
            </div>
            <span className={`badge ${h.priority==="urgent"?"badge-red":h.priority==="high"?"badge-gold":"badge-gray"}`}>
              {h.priority}
            </span>
            <span className={`badge ${h.status==="clean"?"badge-green":"badge-gold"}`}>
              {h.status}
            </span>
            <button className="btn-outline" style={{ padding:"5px 12px", fontSize:10 }}>Assign</button>
          </div>
        ))}
      </div>

      {/* Staff on duty */}
      <div className="panel">
        <div className="panel-hd"><span className="panel-hd-title">Housekeeping Staff</span></div>
        {hkStaff.map(s => (
          <div key={s.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", borderBottom:"1px solid rgba(180,140,80,.07)" }}>
            <div style={{ width:8, height:8, borderRadius:"50%", background:s.status==="on-duty"?"#4a7c59":"#8a7060", flexShrink:0 }}/>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, color:"#2c1f14", fontWeight:400 }}>{s.name}</div>
              <div style={{ fontSize:11, color:"#8a7060", fontWeight:300 }}>{s.role} · {s.shift} shift</div>
            </div>
            <span style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, color:"#c8a05a" }}>{s.tasks}</span>
            <span style={{ fontSize:10, color:"#8a7060" }}>tasks</span>
            <span className={`badge ${s.status==="on-duty"?"badge-green":"badge-gray"}`}>{s.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
